const getRef = (refs, name) => {
  const ref = refs && refs[name];
  return Array.isArray(ref) ? ref[0] : ref;
};

export default getRef;



// WEBPACK FOOTER //
// ./src/utils/getRef.js